import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Footer.scss'
import { githubLink, linkedInLink } from "../constants";

function Footer() {
  return (
    <footer>
      <div>
        <a href={githubLink} target="_blank" rel="noreferrer"><GitHubIcon/></a>
        <a href={linkedInLink} target="_blank" rel="noreferrer"><LinkedInIcon/></a>
      </div>
    </footer>
  );
}

export default Footer;